<template>
  <div>
    <form method="post" @submit.prevent="updateReport">
      <!-- <div class="container table-actions">
        <div>
          Отчет за {{ REPORT.month | getMonth }} {{ REPORT.year }} Статус: {{ REPORT.status }}
        </div>
        <button class="table-actions-button btn-green" type="submit">
          Сохранить
        </button>
      </div> -->

      <div class="table-title">Отчет за {{ REPORT.month | getMonth }} {{ REPORT.year }}</div>
      <div class="categories-top-actions">
        <button class="table-actions-button btn-green" type="submit">
          Сохранить
        </button>
      </div>


      <div class="table-container-inner">
        <table>
          <thead>
          <tr>
            <td class="table-specs" colspan="2" rowspan="2">Характеристики</td>
          </tr>
          <tr class="tr-fixed-height">
          <th class="metall-measure-unit" rowspan="2" colspan="1" scope="colgroup">Единица измерения</th>
          <!-- Hide Remnant -->
          <th class="metall-slot-hidden" colspan="3" scope="colgroup" rowspan="2"
              style="border-top: 1px solid #868686; margin-top: -10px;">
            <button type="button" class="show-btn" @click="showRemnantColumns">
              <i class="fas fa-arrows-alt-h"></i>
            </button>
            <p>Показать</p> <span>остаток</span>
          </th>
          <th class="metall-left-in-stock-botm" colspan="3" scope="colgroup">Остаток металлолома на складе на начало
            месяца
          </th>
          <th class="metall-received" colspan="1" scope="colgroup">
            <button type="button" class="hide-btn" @click="hideRemnantColumns">
              <i class="fas fa-arrows-alt-h"></i>
            </button>
            Поступление
          </th>
          <th class="metall-received" colspan="1" scope="colgroup">
            Реализация на собственные нужды
          </th>
          <th class="metall-received" colspan="1" scope="colgroup">
            Социальное обязательство
          </th>
          <th class="metall-slot-hidden-contract" colspan="1" rowspan="1"
              style="border-top: 1px solid #868686; margin-top: -10px;">
            <button type="button" class="show-btn" @click="showContractColumns">
              <i class="fas fa-arrows-alt-h"></i>
            </button>
            <p>Показать информацию о контракте</p>
          </th>
          <th class="metall-information metall-info-contract-cell" colspan="11" scope="colgroup">
            <button type="button" class="hide-btn" @click="hideContractColumns">
              <i class="fas fa-arrows-alt-h"></i>
            </button>
            Информация по заключенным договорам
            </th>
          <th class="metall-left-in-stock-eotm metall-info-notes-cell" colspan="2" scope="colgroup">Остаток металлолома на складе на конец
            месяца
          </th>
          <th class="metall-slot-hidden-notes" rowspan="2" colspan="1"
              style="border-top: 1px solid #868686; border-right: 1px solid #868686; margin-top: -10px;">
            <button type="button" class="show-btn" @click="showNotesColumns">
              <i class="fas fa-arrows-alt-h"></i>
            </button>
            <p>Показать</p> <span>остаток</span>
          </th>
          <th class="metall-notes metall-info-notes-cell" rowspan="2">
            <button type="button" class="hide-btn" @click="hideNotesColumns">
              <i class="fas fa-arrows-alt-h"></i>
            </button>
            Примечание
          </th>
        </tr>
          <tr>
            <th scope="col" style="background: #36429E; border: none"></th>
            <th scope="col" style="background: #36429E; border: none"></th>
            <th class="metall-slot-hidden" scope="col">...</th>
            <th class="metall-left-in-stock-sub-botm expanded" scope="col">Кол-во</th>
            <th class="metall-left-in-stock-sub-botm" scope="col">Стоимость оценки</th>
            <th class="metall-left-in-stock-sub-botm expanded" scope="col">Сумма</th>
            <th class="metall-received-count" scope="col">Количество</th>
            <th class="metall-slot-hidden-contract" scope="col">...</th>
            <th class="metall-received-count" scope="col">Количество</th>
            <th class="metall-received-count" scope="col">Количество</th>
          <th class="metall-info-sub-count metall-info-contract-cell" scope="col">Общее кол-во по договору</th>
          <th class="metall-info-sub-realization metall-info-contract-cell" scope="col">Способ реализации</th>
          <th class="metall-info-sub-payment metall-info-contract-cell" scope="col">Условия оплаты</th>
          <th class="metall-info-sub-naming metall-info-contract-cell" scope="col">Наименование покупателя</th>
          <th class="metall-info-sub-bin metall-info-contract-cell" scope="col">БИН</th>
          <th class="metall-info-sub-contract-number metall-info-contract-cell" scope="col">Номер договора</th>
          <th class="metall-info-sub-date metall-info-contract-cell" scope="col">Дата договора</th>
          <th class="metall-info-sub-price metall-info-contract-cell expanded" scope="col">Цена за ед. тенге</th>
          <th class="metall-info-sub-sum metall-info-contract-cell" scope="col">Сумма договора, тенге</th>
          <th class="metall-info-sub-exported metall-info-contract-cell" scope="col">Вывезенное количество</th>
          <th class="metall-info-sub-left metall-info-contract-cell" scope="col">Остаток по договору</th>
          <th class="metall-left-in-stock-sub-eotm metall-info-notes-cell expanded" scope="col">Кол-во</th>
          <th class="metall-left-in-stock-sub-eotm metall-info-notes-cell expanded" scope="col">Сумма</th>
          <th class="metall-slot-hidden-notes" style="border-right: 1px solid #868686;">...</th>
          </tr>
          </thead>
          <tbody v-for="(request, request_index) in this.requests" :key="request_index">
          <tr v-for="(contract, index) in request.contracts" :key="contract.id">
            <th class="t-metall-sub-type" scope="rowgroup" v-if="request.is_color">Цветной металл
            </th>
            <th class="t-metall-sub-type" scope="rowgroup" v-else>Черный металл</th>
            <th class="t-metall-sub-type" scope="row">{{ request.category }}</th>
            <!-- <td class="metall-slot-hidden">...</td> -->
            <td>
              T
            </td>
            <td class="metall-slot-hidden">...</td>
            <td class="metall-td-hide">
              <input required :class="'metall-table-input ' + setColor(index)" type="number" min="0" step="0.01"
                     :disabled="isDisabledForMain(index, request_index) || isDisabled(index) && !contract.first"
                     v-model="request.count_before"
                     @change="autoCalculateAfterCount(request_index) || autoCalculateBeforeSum(request_index)"/>
            </td>
            <td class="metall-td-hide">
              <input required :class="'metall-table-input ' + setColor(index)" type="number" min="0" step="0.01"
                     :disabled="isDisabled(index)"
                     v-model="request.price_before"
                     @change="autoCalculateAfterSum(request_index) || autoCalculateBeforeSum(request_index)"/>
            </td>
            <td class="metall-td-hide">
              <input required :class="'metall-table-input total_calculate ' + setColor(index)" type="number" min="0" step="0.01"
                     :disabled="isDisabled(index)"
                     v-model="request.total_before"
                     readonly
                     @change="autoCalculateBeforeSum(request_index)"/>
            </td>
            <td class="metall-td-hide">
              <input required :class="'metall-table-input ' + setColor(index)" type="number" min="0" step="0.01"
                     :disabled="isDisabled(index)"
                     v-model="request.count_come"
                     @change="autoCalculateAfterCount(request_index) || autoCalculateAfterSum(request_index)"/>
            </td>
            <td class="metall-slot-hidden-contract">...</td>
            <td class="metall-td-hide">
              <input required :class="'metall-table-input ' + setColor(index)" type="number" min="0" step="0.01"
                     :disabled="isDisabled(index)"
                     v-model="request.for_own_needs"
                     @change="autoCalculateAfterCount(request_index) || autoCalculateAfterSum(request_index)"/>
            </td>
            <td class="metall-td-hide">
              <input required :class="'metall-table-input ' + setColor(index)" type="number" min="0" step="0.01"
                     :disabled="isDisabled(index)"
                     v-model="request.for_social_commitment"
                     @change="autoCalculateAfterCount(request_index) || autoCalculateAfterSum(request_index)"/>
            </td>
            <td class="metall-info-contract-cell">
              <input class="metall-table-input contr_count" type="number" min="0" step="0.01" :readonly="!contract.first"
                     :id="index"
                     v-model="contract.contr_count"
                     @change="change_contr_count(request_index, index) || autoCalculateContrTotal(request_index, index)
                     || autoCalculateCountBalance(request_index, index) || autoCalculateAfterCount(request_index)
                     || autoCalculateAfterSum(request_index) || deleteRequiredSelect(request_index, index)"/>
            </td>
            <td class="metall-info-contract-cell">
              <select :id="'edit_select_contr_method_' + index" :class="'report-table-s selects_' + request_index + '_' + index" :disabled="!contract.first"
                      v-model="contract.contr_method">
                <option value="">Выберите значение</option>
                <option value="Аукцион">Аукцион</option>
                <option value="Товарная биржа">Товарная биржа</option>
                <option value="Прямая адресная продажа">Прямая адресная продажа</option>
              </select>
            </td>
            <td class="metall-info-contract-cell">
              <select :id="'edit_select_contr_conditions_' + index" :class="'report-table-s selects_' + request_index + '_' + index" :disabled="!contract.first"
                      v-model="contract.contr_conditions">
                <option value="">Выберите значение</option>
                <option value="100% предоплата">100% предоплата</option>
                <option value="30% предоплата">30% предоплата</option>
              </select>
            </td>
            <td class="metall-info-contract-cell">
              <input :id="'edit_contr_impl_' + index" :readonly="!contract.first" :class="'metall-table-input selects_' + request_index + '_' + index" type="text"
                     v-model="contract.contr_impl"/>
            </td>
            <td class="metall-info-contract-cell">
              <input :id="'edit_bin_company_' + index" :readonly="!contract.first" :class="'bin-input-edit metall-table-input selects_' + request_index + '_' + index"
                     type="text" min="0" maxlength="14"
                     v-model="contract.bin_company"/>
            </td>
            <td class="metall-info-contract-cell">
              <input :id="'edit_contr_number_' + index" :readonly="!contract.first" :class="'metall-table-input selects_' + request_index + '_' + index"
                     type="text"
                     v-model="contract.contr_number"/>
            </td>
            <td class="metall-info-contract-cell">
              <input :id="'edit_contr_date_' + index" :readonly="!contract.first" :class="'metall-table-input selects_' + request_index + '_' + index" type="date"
                     v-model="contract.contr_date"/>
            </td>
            <td class="metall-info-contract-cell">
              <input :readonly="!contract.first" :class="'metall-table-input selects_' + request_index + '_' + index" type="number" min="0.01" step="0.01"
                     v-model="contract.contr_unit_price"
                     @change="autoCalculateContrTotal(request_index, index)"/>
            </td>
            <td class="metall-info-contract-cell">
              <input :class="'total_calculate metall-table-input selects_' + request_index + '_' + index" type="number" min="0" step="0.01"
                     readonly
                     v-model="contract.contr_total"
                     @change="autoCalculateContrTotal(request_index, index)"/>
            </td>
            <td class="metall-info-contract-cell">
              <input required class="metall-table-input" type="number" min="0" step="0.01"
                     v-model="contract.contr_count_gone"
                     @change="autoCalculateContrTotal(request_index, index) || autoCalculateCountBalance(request_index, index) || autoCalculateAfterCount(request_index)"/>
            </td>
            <td class="metall-info-contract-cell">
              <input :class="'metall-table-input selects_' + request_index + '_' + index + ' ' + isFirstTotal()" type="number" min="0" step="0.01"
                     v-model="contract.contr_count_balance"
                     :readonly="isFirst()"
                     @change="autoCalculateCountBalance(request_index, index)"/>
            </td>
            <td class="metall-slot-hidden-notes" style="border-right: 1px solid #868686;">...</td>
            <td class="metall-info-notes-cell">
              <input required :class="'metall-table-input total_calculate ' + setColor(index)" type="number" min="0" step="0.01"
                     :disabled="isDisabled(index)"
                     v-model="request.count_after"
                     readonly
                     @change="autoCalculateAfterCount(request_index) || autoCalculateAfterSum(request_index)"/>
            </td>
            <td class="metall-info-notes-cell">
              <input required :class="'metall-table-input total_calculate ' + setColor(index)" type="number" min="0" step="0.01"
                     :disabled="isDisabled(index)"
                     v-model="request.total_after"
                     readonly
                     @change="autoCalculateAfterSum(request_index)"/>
            </td>
            <td class="metall-info-notes-cell">
              <input class="metall-table-input" type="text"
                     v-model="contract.comment"/>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </form>
  </div>
</template>

<script>
import {isApproved, isImpl, isRecipient, isSaveChange} from "@/variables";
import {mapGetters} from "vuex";

export default {
  name: "EditTableTwo",
  data() {
    return {
      reports: this.REPORT,
      initCategories: [],
      isApproved: false,
      isImpl: false,
      isRecipient: false,
      requests: [],
      old_balance: {}
    }
  },
  methods: {
    isFirstTotal(){
      if (this.REPORT.first){
        return '';
      }
      return 'total_calculate';
    },
    isFirst(){
      if (this.REPORT.first){
        return false;
      }
      return true;
    },
    getInitCategories() {
      this.$store.dispatch('getInitCategories', this.$route.params.id).then((response) => {
        this.initCategories = response.init_categories;
      })
    },
    getReport() {
      this.$store.dispatch('getReport', this.$route.params.id).then((response) => {
        this.requests = response.requests;
        for (let i = 0; i < this.requests.length; ++i) {
          let contracts = this.requests[i].contracts;
          this.old_balance[i] = {}
          for (let j = 0; j < contracts.length; ++j) {
            this.old_balance[i][j] = parseFloat(contracts[j].contr_count_balance) + parseFloat(contracts[j].contr_count_gone);
          }
        }
      });
    },
    updateReport() {
      let formData = {
        requests: this.requests,
        report_id: this.$route.params.id,
        is_save_change: isSaveChange(this.REPORT.status)
      }
      this.$store.dispatch('updateReport', formData)
    },
    change_contr_count(request_index, index) {
      this.old_balance[request_index][index] = this.requests[request_index].contracts[index].contr_count;
    },

    autoCalculateContrTotal(request_index, index) {
      this.requests[request_index].contracts[index].contr_total = (parseFloat(this.requests[request_index].contracts[index].contr_count) * parseFloat(this.requests[request_index].contracts[index].contr_unit_price)).toFixed(2);

    },

    autoCalculateCountBalance(request_index, index) {

      // let contr_count_balance = parseFloat(this.requests[request_index].contracts[index].contr_count_balance);
      // let contr_count = parseFloat(this.requests[request_index].contracts[index].contr_count);
      // let contr_count_gone = parseFloat(this.requests[request_index].contracts[index].contr_count_gone);
      // if (contr_count - contr_count_gone === contr_count_balance){
      //   this.requests[request_index].contracts[index].contr_count_balance = (parseFloat(contr_count) - parseFloat(contr_count_gone)).toFixed(2);
      // } else {
      //   this.requests[request_index].contracts[index].contr_count_balance = (parseFloat(contr_count_balance) - parseFloat(contr_count_gone)).toFixed(2);
      // }
      if (this.REPORT.first === false) {
        this.requests[request_index].contracts[index].contr_count_balance = (parseFloat(this.old_balance[request_index][index]) - parseFloat(this.requests[request_index].contracts[index].contr_count_gone)).toFixed(2);
      }
    },
    autoCalculateAfterCount(request_index) {
      let contracts = this.requests[request_index].contracts;
      let gone_sum = 0.0;
      for (let i = 0; i < contracts.length; ++i) {
        gone_sum += parseFloat(contracts[i].contr_count_gone);
      }
      this.requests[request_index].count_after = (parseFloat(this.requests[request_index].count_before)
          + parseFloat(this.requests[request_index].count_come) - parseFloat(this.requests[request_index].for_own_needs)
          - parseFloat(this.requests[request_index].for_social_commitment)
          - parseFloat(gone_sum)).toFixed(2);
      this.autoCalculateAfterSum(request_index);

    },
    autoCalculateAfterSum(request_index) {
      this.requests[request_index].total_after = (parseFloat(this.requests[request_index].count_after) * parseFloat(this.requests[request_index].price_before)).toFixed(2);

    },
    autoCalculateBeforeSum(request_index) {
      this.requests[request_index].total_before = (parseFloat(this.requests[request_index].count_before) * parseFloat(this.requests[request_index].price_before)).toFixed(2);

    },
    setColor(index) {
      if (index) {
        return 'duplicate';
      }
      return '';
    },

    isDisabled(index) {
      if (index) {
        return true;
      }

      return false;
    },
    isDisabledForMain(index, request_index) {
      if (this.initCategories.includes(this.requests[request_index].category_full)) {
        return true;
      }

      return false;
    },

    hideRemnantColumns() {
      let metallLeft = document.querySelectorAll('.metall-left-in-stock-botm'),
          metallSubColumns = document.querySelectorAll('.metall-left-in-stock-sub-botm'),
          metallReceived = document.querySelector('.metall-received'),
          metallReceivedCount = document.querySelector('.metall-received-count'),
          metallTdHide = document.querySelectorAll('.metall-td-hide'),
          metallTdHidden = document.querySelectorAll('.metall-slot-hidden'),
          hideButtons = document.querySelectorAll('.hide-btn');

      metallLeft.forEach(item => {
        if (item) {
          item.classList.toggle('table-column-hide')
        }
      })

      metallReceived.classList.toggle('table-column-hide');
      metallReceivedCount.classList.toggle('table-column-hide');

      metallSubColumns.forEach(item => {
        if (item) {
          item.classList.toggle('table-column-hide')
        }
      })

      metallTdHide.forEach(item => {
        if (item) {
          item.classList.toggle('table-column-hide')
        }
      })

      metallTdHidden.forEach(item => {
        item.style.display = 'block'
      })

      hideButtons.forEach(item => {
        item.disabled = true;
      })


    },
    deleteRequiredSelect(request_index, index) {
      var all_select = document.getElementsByClassName('selects_' + request_index + '_' + index);
      if (this.requests[request_index].contracts[index].contr_count == 0) {
        Array.prototype.forEach.call(all_select, function (el) {
          el.removeAttribute('required', 'required');
        });
        this.requests[request_index].contracts[index].contr_unit_price = 0;
        this.requests[request_index].contracts[index].contr_total = 0;
        this.requests[request_index].contracts[index].contr_count_gone = 0;
        this.requests[request_index].contracts[index].contr_count_balance = 0;
      } else {
        Array.prototype.forEach.call(all_select, function (el) {
          el.setAttribute('required', 'required');
        });
      }
    },
    checkRequired() {
      var selects = document.getElementsByClassName('contr_count');
      // for (let i = 0; i < selects.length; ++i){
      //   let index = selects[i].id;
      //   let select_contr_method = document.getElementById('select_contr_method_' + el.id)
      // }


      Array.prototype.forEach.call(selects, function (el) {
        if (el.value == 0) {
          let index = el.id;
          let select_contr_method = document.getElementById('edit_select_contr_method_' + index);
          select_contr_method.removeAttribute('required');
          let select_contr_conditions = document.getElementById('edit_select_contr_conditions_' + index);
          select_contr_conditions.removeAttribute('required');
          let contr_date = document.getElementById('edit_contr_date_' + index);
          contr_date.removeAttribute('required');

          let edit_contr_impl = document.getElementById('edit_contr_impl_' + index);
          edit_contr_impl.removeAttribute('required');

          let edit_bin_company = document.getElementById('edit_bin_company_' + index);
          edit_bin_company.removeAttribute('required');

          let edit_contr_number = document.getElementById('edit_contr_number_' + index);
          edit_contr_number.removeAttribute('required');
        }
      });
    },
    showRemnantColumns() {
      let metallLeft = document.querySelectorAll('.metall-left-in-stock-botm'),
          metallSubColumns = document.querySelectorAll('.metall-left-in-stock-sub-botm'),
          metallReceived = document.querySelector('.metall-received'),
          metallReceivedCount = document.querySelector('.metall-received-count'),
          metallTdHide = document.querySelectorAll('.metall-td-hide'),
          metallTdHidden = document.querySelectorAll('.metall-slot-hidden'),
          hideButtons = document.querySelectorAll('.hide-btn');

      metallLeft.forEach(item => {
        if (item) {
          item.classList.toggle('table-column-hide')
        }
      })

      metallReceived.classList.toggle('table-column-hide');
      metallReceivedCount.classList.toggle('table-column-hide');

      metallSubColumns.forEach(item => {
        if (item) {
          item.classList.toggle('table-column-hide')
        }
      })

      metallTdHide.forEach(item => {
        if (item) {
          item.classList.toggle('table-column-hide')
        }
      })

      metallTdHidden.forEach(item => {

        item.style.display = 'none'

      })

      hideButtons.forEach(item => {
            item.disabled = false
          })
    },
        hideContractColumns() {
      let metallInformation = document.querySelector('.metall-information'),
          metallInfoContractCell = document.querySelectorAll('.metall-info-contract-cell'),
          metallReceivedCount = document.querySelector('.metall-received-count'),
          metallTdHide = document.querySelectorAll('.metall-td-hide'),
          metallTdHiddenContract = document.querySelectorAll('.metall-slot-hidden-contract'),
          hideButtons = document.querySelectorAll('.hide-btn');

          metallInfoContractCell.forEach(item => {
            item.classList.toggle('table-column-hide')
          })

          metallTdHiddenContract.forEach(item => {
            item.style.display = 'block'
          })

          hideButtons.forEach(item => {
            item.disabled = true;
          })

    },
    showContractColumns() {
      let metallInformation = document.querySelector('.metall-information'),
          metallInfoContractCell = document.querySelectorAll('.metall-info-contract-cell'),
          metallReceivedCount = document.querySelector('.metall-received'),
          metallTdHide = document.querySelectorAll('.metall-td-hide'),
          metallTdHiddenContract = document.querySelectorAll('.metall-slot-hidden-contract'),
          hideButtons = document.querySelectorAll('.hide-btn');

          metallInfoContractCell.forEach(item => {
            if (item) {
              item.classList.toggle('table-column-hide')
            }
          })

          metallTdHiddenContract.forEach(item => {
            item.style.display = 'none'
          })

          hideButtons.forEach(item => {
            item.disabled = false
          })


    },
    hideNotesColumns() {
      let metallInformation = document.querySelector('.metall-notes'),
          metallInfoNotesCells = document.querySelectorAll('.metall-info-notes-cell'),
          metallTdHiddenNotes = document.querySelectorAll('.metall-slot-hidden-notes'),
          hideButtons = document.querySelectorAll('.hide-btn');


          metallInfoNotesCells.forEach(item => {
            item.classList.toggle('table-column-hide')
          })

          metallTdHiddenNotes.forEach(item => {
            item.style.display = 'block'
          })

          hideButtons.forEach(item => {
            item.disabled = true
          })
    },
    showNotesColumns() {
      let metallInformation = document.querySelector('.metall-notes'),
          metallInfoNotesCells = document.querySelectorAll('.metall-info-notes-cell'),
          metallTdHiddenNotes = document.querySelectorAll('.metall-slot-hidden-notes'),
          hideButtons = document.querySelectorAll('.hide-btn');


          metallInfoNotesCells.forEach(item => {
            item.classList.toggle('table-column-hide')
          })

          metallTdHiddenNotes.forEach(item => {
            item.style.display = 'none'
          })

          hideButtons.forEach(item => {
            item.disabled = false
          })
    },
    appendSpaceAtFly(){
      let binEditInputs = document.querySelectorAll('.bin-input-edit');
      binEditInputs.forEach(item => {
        item.addEventListener('input', function (e) {
          let target = e.target, position = target.selectionEnd, length = target.value.length;

          target.value = target.value.replace(/\s/g, '').replace(/(\d{4})/g, '$1 ').trim();
          target.selectionEnd = position += ((target.value.charAt(position - 1) === ' ' && target.value.charAt(length - 1) === ' ' && length !== target.value.length) ? 1 : 0);
        })
      })
    }
  },
  mounted() {
    this.getReport();
    this.getInitCategories();
    this.isApproved = isApproved(this.USER.ouser);
    this.isImpl = isImpl(this.USER.ouser);
    this.isRecipient = isRecipient(this.USER.ouser);
    this.appendSpaceAtFly();

    // document.querySelectorAll('.bin-input-edit').addEventListener('input', function (e) {
    //   let target = e.target, position = target.selectionEnd, length = target.value.length;
    //
    //   target.value = target.value.replace(/\s/g, '').replace(/(\d{4})/g, '$1 ').trim();
    //   target.selectionEnd = position += ((target.value.charAt(position - 1) === ' ' && target.value.charAt(length - 1) === ' ' && length !== target.value.length) ? 1 : 0);
    // });
  },
  updated() {
    this.checkRequired();
  },
  computed: {
    ...
        mapGetters([
          'REPORT',
          'USER'
        ]),
  }
}
</script>

<style scoped>
.duplicate {
  background: #717171 !important;
  color: #fff;
}

.table-container {
  overflow-x: auto;
  padding: 0 2rem;
  /* max-width: 1800px; */
  margin: 0 auto;
}

.table-container-inner {
  padding: .5rem;
  /* padding: 1rem 2rem;
  margin-right: 2rem; */
  margin: 0 2rem;
  /* margin: 1rem 2rem; */
  overflow-x: auto;
  max-width: 100vw;
}


.table-title {
  padding: 1rem;
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
}

table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  border-bottom: 1px solid black;
}

th, td {
  border: 1px solid #868686;
  height: 30px;
  padding: 0 1rem;
}

.expanded {
  padding: 0 2rem;
}

.table-specs {
  background: #36429E;
  width: 100px;
  height: 100px;
  color: white;
  text-align: center;
  border-top-left-radius: 10px;
  border: none;
  font-size: 1.5rem;
  vertical-align: bottom;
}

.tr-fixed-height {
  height: 100px;
}

.t-metall-type {
  height: 296px;
  width: 120px;
}

.t-metall-sub-type {
  width: 130px;
  height: 60px;
}

.metall-left-in-stock-botm,
.metall-left-in-stock-eotm {
  /* width: 180px; */
  height: 75px;
}

.metall-left-in-stock-sub-botm,
.metall-left-in-stock-sub-eotm {
  /* width: 90px; */
  height: 50px;
}

.metall-received {
  position: relative;
  width: 120px;
}

.metall-information,
.metall-notes {
  position: relative;
}

.table-column-hide {
  /* opacity: 0; */
  /* visibility: hidden; */
  /* appearance: none; */
  display: none;
  /* visibility: collapse; */
}

.table-column-show {
  opacity: 1;
}

.hide-btn,
.show-btn {
  position: absolute;
  top: 0;
  right: 12px;
  padding: .5rem;
  background: none;
  border: none;
}

.hide-btn:focus,
.show-btn:focus {
  outline: none;
}

.hide-btn i::before,
.show-btn i::before {
  font-size: 1.2rem;
}

.metall-info-sub-count {
  width: 120px;
}

.metall-info-sub-realization {
  width: 120px;
}

.metall-info-sub-payment {
  width: 90px;
}

.metall-info-sub-naming {
  width: 120px;
}

.metall-info-sub-bin {
  /* width: 120px !important; */
  padding: 0 3rem;
}

.metall-info-sub-contract-number {
  width: 120px;
}

.metall-info-sub-date {
  width: 110px;
}

.metall-info-sub-price {
  width: 140px;
}

.metall-info-sub-sum {
  width: 140px;
}

.metall-info-sub-exported {
  width: 140px;
}

.metall-info-sub-left {
  width: 140px;
}


/* hidden columns */
.metall-slot-hidden,
.metall-slot-hidden-contract,
.metall-slot-hidden-notes {
  position: relative;
  /* width: 100px; */
  /* height: 75px; */
  display: none;
  border: none;
  /* border-bottom: 1px solid #868686; */
  margin: 0 !important;
}

.metall-slot-hidden p,
.metall-slot-hidden-contract p,
.metall-slot-hidden-notes {
  line-height: 75px;
}

.metall-slot-hidden-notes {
  border-right: 1px solid black;
}


.metall-table-input {
  width: 100%;
  height: 100%;
  border: none;
  text-align: center;
}

input:focus {
  border: none;
  outline: none;
  height: 70px;
}

.categories-top-actions {
  margin: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.table-actions-button {
  padding: 1rem 2rem;
  border: none;
  outline: none;
  border-radius: 10px;
  margin-left: 1rem;
  cursor: pointer;
  font-size: 1.1rem;
}

.btn-green {
  background: #7AD38D;
  color: white;
}

.total_calculate {
  background: rgba(89, 36, 36, 0.27);
}

.report-table-s {
  height: 100%;
  border: none;
  font-size: .8rem;
  background: none;
}
</style>